import { render, staticRenderFns } from "./PowerWriterView.vue?vue&type=template&id=97f72384&scoped=true"
import script from "./PowerWriterView.vue?vue&type=script&lang=js"
export * from "./PowerWriterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f72384",
  null
  
)

export default component.exports